import './mobileBar.less';

const mobileBar = () => {
    let catOpener = document.getElementById('js-cat-opener');
    catOpener
        ? catOpener.addEventListener('click',()=>{})
        : null;
};

export default mobileBar;


// WEBPACK FOOTER //
// ./components/mobileBar/mobileBar.js